module.exports = __webpack_public_path__ + "static/media/mapbg_desktop.893b6b2c.png";